import { render, staticRenderFns } from "./AsideBarWorkItems.vue?vue&type=template&id=1c5e52e6&scoped=true"
import script from "./AsideBarWorkItems.vue?vue&type=script&lang=js"
export * from "./AsideBarWorkItems.vue?vue&type=script&lang=js"
import style0 from "./AsideBarWorkItems.vue?vue&type=style&index=0&id=1c5e52e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5e52e6",
  null
  
)

export default component.exports